<template>
  <section>
    <b-loading :is-full-page="true" v-model="isLoading" style="z-index: 999999999"></b-loading>
    <b-modal v-model="show" :width="1000" scroll="keep" :on-cancel="closeModal">
      <div class="modal-widget" id="#create_device_cotainer">
        <div class="modal-title">
          <h2 class="title">Asignar permisos</h2>
        </div>
        <div class="modal-body">
          <div class="form-container">
            <div class="columns mb-2">
              <div class="column">
                <CompanySelector v-model="company"/>
              </div>
              <div class="column">
                <b-field label="Dispositivo *">
                  <b-select
                      placeholder="Disposiitvo"
                      expanded
                      v-model="deviceId"
                      name="deviceId"
                  >
                    <option
                        v-for="option in devicesList"
                        :value="option.code"
                        :key="option.code"
                        :id="option.code"
                    >
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column"></div>
            </div>
          </div>
          <div class="apps-permises-container">
            <div class="columns device-modules mt-1">
              <div class="columns pt-3 pb-3 flex-center" v-if="loadingModules">
                <Loader/>
              </div>
              <div class="columns container" v-if="!loadingModules">
                <div
                    class="column"
                    v-for="(moduleGroup, moduleIndex) in moduleGroups"
                    :value="moduleGroup.app.code"
                    :key="moduleGroup.app.code"
                    :id="moduleGroup.app.code">
                  <div class="group-container">
                    <div class="group-header">
                      <div class="check-group-header">
                        <vs-checkbox
                            class="justify-content-start checkbox-item"
                            v-model="$data.moduleGroups[moduleIndex].selected"
                            v-on:change="onChangeCheckModule(moduleGroup)">
                          {{ moduleGroup.app.title }}
                        </vs-checkbox>
                      </div>
                      <div class="options">
                        <vs-button
                            color="primary"
                            icon="add"
                            class="btn-option btn-add-discount"
                            title="Agregar descuento"
                            @click="addDiscount"
                            v-if="moduleGroup.app.url === 'discount'"></vs-button>
                        <vs-button
                            color="success"
                            icon="settings"
                            class="btn-option btn-config-discount"
                            title="Configuración"
                            @click="configEntryOut"
                            v-if="moduleGroup.app.url === 'entry_out'"></vs-button>
                      </div>
                    </div>
                    <div class="group-body">
                      <ul class="activities-container">
                        <li
                            class="activity-item"
                            v-for="(
                            activity, activityIndex
                          ) in moduleGroup.activities"
                            :value="activity.code"
                            :key="activityIndex"
                            :id="activity.code"
                        >
                          <vs-checkbox
                              class="justify-content-start checkbox-item"
                              :title="activity.title"
                              v-on:change="onChangeCheckModule(activity)"
                              :disabled="
                              !$data.moduleGroups[moduleIndex].selected
                            "
                              v-model="
                              $data.moduleGroups[moduleIndex].activities[
                                activityIndex
                              ].selected
                            "
                          >
                            {{ activity.title }}
                          </vs-checkbox>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column text-right">
              <vs-button
                  color="danger"
                  type="filled"
                  class="pl-5 pr-5"
                  icon="close"
                  @click="closeModal"
              >Cancelar
              </vs-button
              >
              <vs-button
                  color="success"
                  class="ml-3 pl-5 pr-5"
                  icon="save"
                  type="filled"
                  @click="saveConfiguration"
                  :disabled=" this.isLoading || validate()">
                Guardar
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import CompanySelector from "@/components/Shared/CompanySelector";
import Loader from "@/components/Shared/Loader.vue";
import {STATUS} from "@/global/constants";
import {sortByKeyName} from "@/global/utils";
import {validator} from "@/global/validator";
import {ActivityType} from "@/global/constants";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";

export default {
  components: {CompanySelector, Loader},
  data: () => ({
    isLoading: false,
    activities: [],
    loadingModules: false,
    show: false,
    company: null,
    consecutive: null,
    checkIdCar: null,
    device: null,
    deviceName: null,
    imei: null,
    graceTime: null,
    resolution: null,
    technology: null,
    initialValue: null,
    technologies: [],
    devicesList: [],
    resolutions: [],
    moduleGroups: [],
    deviceActivities: [],
    deviceId: null,
    loadModule: true
  }),
  watch: {
    async moduleGroups() {
      if (this.deviceId && this.loadModule) {
        this.deviceActivities = await deviceEndpoint.getDeviceActivated(this.deviceId);
        // [DEBUG-PERMISOS] filas device_activity crudas que llegan del backend
        console.log(
            "[DEBUG-PERMISOS] deviceActivities crudas (deviceId=" + this.deviceId + "): " +
            JSON.stringify(
                (this.deviceActivities || []).map((d) => ({
                  daPk: d.code,
                  activityCode: d.activity && d.activity.code,
                  activityApp: d.activity && d.activity.app,
                  actionType: d.activity && d.activity.actionType,
                  purchasedModule: d.purchasedModule,
                }))
            )
        );
        this.autoSelectActivities();
      }
      this.loadingModules = false;
    },
    async company(company) {
      if (!company) {
        return;
      }
      this.loadingModules = true;
      this.devicesList = await deviceEndpoint.getCompanyDevicesList(company);
      const groupList = await deviceEndpoint.getModuleGroups(company);
      this.moduleGroups = this.parseModules(groupList);
      // [DEBUG-PERMISOS] catálogo de módulos (app.code + título + actividades)
      console.log(
          "[DEBUG-PERMISOS] moduleGroups catálogo: " +
          JSON.stringify(
              this.moduleGroups.map((g) => ({
                appCode: g.app && g.app.code,
                titulo: g.app && g.app.title,
                actividades: g.activities.map((a) => ({
                  title: a.title,
                  code: a.code,
                  actionType: a.actionType,
                  ownerCode: a.originalActivity ? a.originalActivity.code : a.code,
                  keyListName: a.keyListName || null,
                  listNameType: a.listNameType || null,
                })),
              }))
          )
      );
    },
  },
  methods: {
    configEntryOut() {
      let routeData = this.$router.resolve({
        name: "Editar Dispositivo",
        query: {code: this.deviceId},
      });
      window.open(routeData.href, "_blank");
    },
    addDiscount() {
      window.open(`/parkapp/view/discounts?companyId=${this.company}`);
    },
    onChangeCheckModule(object) {
      this.loadModule = false;
      // Fix C: el "app" de referencia según el origen del evento:
      // - encabezado de módulo: object.app.code
      // - actividad "GE"/estática: object.app (número)
      // - actividad dinámica expandida (Ingreso de/Salida de X): sin object.app,
      //   se toma de object.originalActivity.app
      let targetAppCode =
          object.app && typeof object.app === "object"
              ? object.app.code
              : object.app;
      if (targetAppCode == null && object.originalActivity) {
        targetAppCode = object.originalActivity.app;
      }
      if (object.actionType === "GE") {
        const list = [...this.moduleGroups];
        this.moduleGroups = list.map((group) => {
          if (group.app.code === object.app) {
            group.touched = true;
            group.activities = group.activities.map((activity) => {
              return {...activity, selected: object.selected};
            });
          }
          return group;
        });
        return;
      }
      if (object.activities) {
        const list = [...this.moduleGroups];
        this.moduleGroups = list.map((group) => {
          if (group.app.code === object.app.code) {
            group.touched = true;
            group.timestamp = new Date().getTime();
            group.activities = group.activities.map((activity) => {
              return {...activity, selected: object.selected, deleted: !object.selected};
            });
          }
          return group;
        });
        return;
      }
      // Actividad individual: marcar su módulo como tocado (el v-model ya cambió
      // activity.selected).
      const group = this.moduleGroups.find(
          (g) => g.app && g.app.code === targetAppCode
      );
      if (group) {
        group.touched = true;
      }
    },
    setData({deviceId, company}) {
      this.deviceId = deviceId;
      this.company = company;
    },
    validate() {
      const rules = [{field: "company"}, {field: "deviceId"}];
      const {result} = validator(this, rules);
      // Paso C: misma semántica que getDeviceData(). Hay algo que enviar si queda
      // alguna actividad activa o si hay bajas pendientes (actividad ya guardada
      // que quedó sin seleccionar, incluido el caso de desmarcar el módulo
      // completo). El grupo sólo anula cuando está EXPLÍCITAMENTE desmarcado.
      const hasChanges = this.moduleGroups.some((group) => {
        // Fix C: si el usuario tocó el módulo, siempre hay algo que guardar
        // (aunque solo sea reconciliar/limpiar filas huérfanas).
        if (group.touched) {
          return true;
        }
        const groupUnchecked = group.selected === false;
        return group.activities.some((activity) => {
          const active = activity.selected && !groupUnchecked;
          return active || (activity.saved && !active);
        });
      });
      return (!result && !hasChanges);
    },

    replaceActivities({app, actionType, keyName, initialsText = null}) {
      const index = app.activities.findIndex(
          (activity) =>
              activity.actionType === actionType && !activity.originalActivity
      );
      const activity = index >= 0 ? app.activities[index] : null;
      let list = [];
      if (index >= 0 && Array.isArray(activity[keyName])) {
        app.activities.splice(index, 1);
      }
      if (!initialsText && activity && actionType === activity.actionType) {
        app.activities = app.activities.concat(
            activity[keyName].map((item) => {
              return {
                ...item,
                keyListName: keyName,
                originalActivity: activity,
              };
            })
        );
      }
      if (Array.isArray(initialsText) && activity) {
        initialsText.forEach((initText) => {
          list = list.concat(
              activity[keyName].map((item) => {
                return {
                  ...item,
                  keyListName: keyName,
                  listNameType: initText.code,
                  title: `${initText.text}${initText.text ? " " : ""}${
                      item.title
                  }`,
                  originalActivity: activity,
                };
              })
          );
        });
      }
      app.activities = sortByKeyName(app.activities.concat(list), "title");
    },
    parseModules(list = []) {
      list.forEach((app) => {
        this.replaceActivities({
          app,
          actionType: ActivityType.VOUCHER,
          keyName: "vouchers",
          initialsText: [{code: "vo", text: ""}],
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.VEHICLE_TYPES,
          keyName: "vehicleTypes",
          initialsText: [
            {code: "entry", text: "Ingreso de"},
            {code: "out", text: "Salida de"},
          ],
        });
        this.replaceActivities({
          app,
          actionType: ActivityType.PAY_TYPES,
          keyName: "vehicleTypes",
          initialsText: [{code: "pay", text: "Pago de "}],
        });
      });
      // Paso A: inicializar el estado (selected/saved) en grupos y actividades
      // ANTES de que el árbol se vuelva reactivo al asignarse a this.moduleGroups.
      // Los objetos que devuelve el backend no traen estas propiedades y, en Vue 2,
      // agregarlas después no las hace reactivas: el v-model del encabezado y el
      // :disabled de las actividades quedaban desincronizados y getDeviceData()
      // podía leer un moduleGroup.selected obsoleto al guardar.
      list.forEach((group) => {
        if (typeof group.selected !== "boolean") {
          group.selected = false;
        }
        // Fix C: marca si el usuario interactuó con este módulo en esta sesión.
        // Sólo los módulos "touched" reconcilian sus device_activities huérfanas
        // al guardar (ver getDeviceData); un módulo intacto nunca se toca.
        if (typeof group.touched !== "boolean") {
          group.touched = false;
        }
        group.activities = group.activities.map((activity) => ({
          selected: false,
          saved: false,
          ...activity,
        }));
      });
      return list;
    },
    getDeviceData() {
      const deviceActivities = [];
      const _dbg = []; // [DEBUG-PERMISOS]
      this.moduleGroups.forEach((moduleGroup) => {
        // Paso B: el estado real de cada actividad lo llevan activity.selected
        // (lo propaga el v-model del hijo, la rama del encabezado y la rama GE).
        // Sólo tratamos el grupo como red de seguridad cuando está EXPLÍCITAMENTE
        // desmarcado (=== false); un grupo aún sin tocar (undefined) no debe
        // anular actividades recién marcadas.
        const groupUnchecked = moduleGroup.selected === false;
        moduleGroup.activities.forEach((activity) => {
          const active = activity.selected && !groupUnchecked;
          const deleted = activity.saved && !active;
          // [DEBUG-PERMISOS] traza de decisión por actividad
          _dbg.push({
            modulo: moduleGroup.app && moduleGroup.app.title,
            appCode: moduleGroup.app && moduleGroup.app.code,
            groupSelected: moduleGroup.selected,
            titulo: activity.title,
            code: activity.code,
            ownerCode: activity.originalActivity
                ? activity.originalActivity.code
                : activity.code,
            keyListName: activity.keyListName || null,
            listNameType: activity.listNameType || null,
            selected: activity.selected,
            saved: activity.saved,
            active: active,
            deleted: deleted,
            emitido: active || deleted,
          });
          if (active || deleted) {
            let deviceActivityIndex = deviceActivities.findIndex((item) => {
              const activityCode = activity.originalActivity
                  ? activity.originalActivity.code
                  : activity.code;
              return item.activity.code == activityCode;
            });

            const resumeActivity = {
              keyListName: activity.keyListName,
              listNameType: activity.listNameType,
              codeListItem: activity.code,
              enable: true,
              selected: true,
            };

            let deviceActivity = {
              device: {
                code: this.deviceId,
              },
              activity: {
                code: activity.originalActivity
                    ? activity.originalActivity.code
                    : activity.code,
              },
              status: deleted ? STATUS.DELETED : STATUS.ACTIVE,
              purchasedModule: !deleted ? [resumeActivity] : [],
            };
            if (deviceActivityIndex >= 0) {
              if (!deleted) {
                deviceActivities[deviceActivityIndex].status = STATUS.ACTIVE;
                deviceActivities[deviceActivityIndex].purchasedModule.push(
                    resumeActivity
                );
              }
            } else {
              deviceActivities.push(deviceActivity);
            }
          }
        });
      });

      // Fix C: reconciliación de device_activities huérfanas.
      // Cada device_activity pertenece a UN módulo, identificado por
      // deviceActivity.activity.app === moduleGroup.app.code (aunque las
      // actividades se repitan o compartan códigos entre módulos). Para cada
      // módulo que el usuario TOCÓ en esta sesión, toda fila almacenada de ese
      // módulo que no haya quedado en el payload como activa se da de baja
      // (status "D"). Así se limpian filas que quedaron bajo una actividad
      // "dueña" distinta a la que la carga actual expandió (deriva de orden del
      // catálogo) o bajo actividades duplicadas que la UI no gestiona.
      const _dbgRecon = [];
      const emittedCodes = new Set(
          deviceActivities.map((da) => String(da.activity.code))
      );
      (this.deviceActivities || []).forEach((stored) => {
        const activityCode = stored.activity && stored.activity.code;
        const activityApp = stored.activity && stored.activity.app;
        if (activityCode == null || activityApp == null) {
          return;
        }
        if (emittedCodes.has(String(activityCode))) {
          return;
        }
        const ownerGroup = this.moduleGroups.find(
            (g) => g.app && g.app.code === activityApp
        );
        // Sólo módulos existentes en el catálogo actual y tocados por el usuario.
        if (!ownerGroup || !ownerGroup.touched) {
          return;
        }
        emittedCodes.add(String(activityCode));
        deviceActivities.push({
          device: {code: this.deviceId},
          activity: {code: activityCode},
          status: STATUS.DELETED,
          purchasedModule: [],
        });
        _dbgRecon.push({
          modulo: ownerGroup.app && ownerGroup.app.title,
          appCode: activityApp,
          activityCode: activityCode,
          daPk: stored.code,
        });
      });

      deviceActivities.forEach((deviceActivity) => {
        deviceActivity.purchasedModule = JSON.stringify(
            deviceActivity.purchasedModule
        );
      });

      // [DEBUG-PERMISOS] bajas por reconciliación de huérfanas
      console.log(
          "[DEBUG-PERMISOS] getDeviceData reconciliación huérfanas: " +
          JSON.stringify(_dbgRecon)
      );

      // [DEBUG-PERMISOS] solo lo relevante para la prueba (bicicleta / ingreso y salida)
      console.log(
          "[DEBUG-PERMISOS] getDeviceData trace: " +
          JSON.stringify(
              _dbg.filter((r) =>
                  /bicicleta|ingreso y salida|cambio/i.test(r.modulo || "")
              )
          )
      );

      return {
        code: this.deviceId,
        company: {code: this.company},
        deviceActivities: deviceActivities,
      };
    },
    saveConfiguration() {
      this.isLoading = true;
      const obj = this.getDeviceData();
      // [DEBUG-PERMISOS] payload exacto que se manda a guardar
      console.log("[DEBUG-PERMISOS] PAYLOAD save:", JSON.stringify(obj, null, 2));
      //Primero, tenemos que alternar el método de grabación/actualización.
      //Tenemos que empaquetar la info de los device_activities...
      deviceEndpoint.save(obj)
          .then(info => {
            // [DEBUG-PERMISOS] code de respuesta del backend (>0 = ok)
            console.log("[DEBUG-PERMISOS] respuesta save:", info);
            this.isLoading = false;
            this.closeModal();
            this.$emit("updatedDevice", obj);
          });
    },
    autoSelectActivities() {
      this.moduleGroups.forEach((group) => {
        group.activities = group.activities.map((activity) => {
          let matchedItem = null;
          // Actividad "dueña": para los ítems dinámicos (Ingreso de/Salida de X,
          // vouchers...) es la actividad original de la que se expandieron; para
          // las estáticas, la propia. El guardado siempre escribe en esta.
          const ownerActivityCode = activity.originalActivity
              ? activity.originalActivity.code
              : activity.code;
          const exist = this.deviceActivities.find((deviceActivity) => {
            const value = deviceActivity.purchasedModule
                ? JSON.parse(deviceActivity.purchasedModule)
                : null;
            if (value == null) {
              return false;
            }
            // Sólo la fila de la actividad dueña puede seleccionar esta casilla.
            // Antes se casaba por app + codeListItem: cuando el catálogo tiene
            // actividades TV/VO duplicadas (p.ej. 43 y 84 en un mismo módulo) y
            // ambas filas comparten un mismo ítem, se reenganchaba desde la fila
            // que no es la dueña y las bajas nunca "pegaban" al recargar.
            if (deviceActivity.activity.code != ownerActivityCode) {
              return false;
            }
            const item = value.find(
                (it) =>
                    it.codeListItem == activity.code &&
                    it.keyListName == activity.keyListName &&
                    it.listNameType == activity.listNameType &&
                    (it.enable == null || it.enable)
            );
            if (item) {
              matchedItem = item;
              return true;
            }
            return false;
          });
          if (exist) {
            // Paso D: respetar el `selected` que quedó guardado en el JSON.
            // Una actividad guardada pero deseleccionada debe verse SIN marcar,
            // conservando saved=true para poder darla de baja. Antes se forzaba
            // selected=true y por eso, al desmarcar y guardar, si la fila no se
            // eliminaba volvía a aparecer marcada tras recargar.
            activity.selected = matchedItem ? matchedItem.selected !== false : true;
            activity.saved = true;
            group.selected = true;
            // [DEBUG-PERMISOS] qué fila reenganchó cada casilla dinámica
            if (activity.originalActivity || activity.keyListName) {
              console.log("[DEBUG-PERMISOS] match " + JSON.stringify({
                modulo: group.app && group.app.title,
                titulo: activity.title,
                code: activity.code,
                keyListName: activity.keyListName,
                listNameType: activity.listNameType,
                actividadDuena: ownerActivityCode,
                filaActivityCode: exist.activity && exist.activity.code,
                filaActivityApp: exist.activity && exist.activity.app,
                filaDaPk: exist.code,
                matchedItem: matchedItem,
                quedaSeleccionada: activity.selected,
              }));
            }
          }
          return activity;
        });
      });
    },
    openModal() {
      this.loadModule = true;
      this.show = true;
    },
    closeModal() {
      this.deviceId = null;
      this.show = false;
      this.company = null;
      this.deviceName = null;
      this.imei = null;
      this.deviceTetch = null;
      this.graceTime = null;
      this.technology = null;
      this.initialValue = null;
      this.resolution = null;
      this.moduleGroups = [];
      this.deviceActivities = [];

    },
  },
};
</script>

<style>
.modal-widget {
  background-color: #ffffff;
  border-radius: 5px;
  height: auto;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
}

.modal-widget .btn-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 0;
  box-shadow: none;
  font-size: 1.2em;
  background-color: #f64651;
  color: #ffffff;
}

.modal-widget .btn-close:hover {
  background-color: black;
  color: #ffffff;
}

.modal-widget .modal-title {
  display: block;
  height: 25px;
  text-align: left;
  padding: 10px 15px;
  padding-bottom: 30px;
}

.modal-widget .modal-title .title {
  text-align: left;
  padding: 0;
  margin: 0;
  font-size: 1.5em;
  font-weight: bold;
}

.modal-widget .modal-body {
  display: block;
}

.group-container .group-header {
  padding: 5px 0px;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
}

.checkbox-item {
  padding: 5px 0;
}

.checkbox-item span {
  font-weight: bold;
}

.checkbox-item .vs-checkbox {
  border-color: #1d76fb !important;
}

.columns.device-modules {
  flex-direction: column;
  border-radius: 5px;
  justify-content: center;
  border: 1px solid #e6e6e6;
  background-color: #fafafa;
  margin-bottom: 15px;
  min-height: 300px;
}

.columns.device-modules .container {
  flex-direction: column;
}

.columns.device-modules .activities-container {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  padding: 0 20px;
}

.columns.device-modules .con-slot-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 25px);
}

.input-search {
  max-width: 300px;
}

.group-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #ececec;
  border: 1px solid #dadada;
  padding: 5px 5px !important;
}

.group-header .options {
  margin-left: 5px;
}

.btn-option {
  margin-right: 5px;
  width: 30px !important;
  height: 30px !important;
}
</style>
